import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import LandingPage from "./pages/LandingPage";
import RequireAuth from "./security/RequireAuth";
import PageNotFound from "./pages/PageNotFound";
import Unauthorized from "./pages/Unauthorized";

import Login from "./pages/client/login/Login";
import Register from "./pages/client/login/Register";
import Home from "./pages/client/home/Home";
import Profile from "./pages/client/home/Profile";
import ExamMain from "./pages/client/exam/ExamMain";
import History from "./pages/client/home/History";

import AdminLogin from "./pages/admin/login/AdminLogin";
import Users from "./pages/admin/home/Users";
import Exam from "./pages/admin/home/Exam";
import Result from "./pages/admin/home/Result";
import Question from "./pages/admin/home/Question";
import Topics from "./pages/admin/home/Topics";
import AdminInfo from "./pages/admin/home/AdminInfo";
import AddQuestion from "./pages/admin/home/AddQuestion";
import EditQuestion from "./pages/admin/home/EditQuestion";
import EditUser from "./pages/admin/home/EditUser";
import HistoryViewPage from "./pages/client/home/HistoryViewPage";
import TopicPage from "./pages/client/home/TopicPage";
import ViewExam from "./pages/admin/home/ViewExam";
import LeaderBoard from "./pages/client/home/LeaderBoard";
import ForgotPassword from "./pages/client/login/ForgotPassword";
import ContactSubmitted from "./pages/admin/home/ContactSubmitted";
import ResetPassword from "./pages/client/login/ResetPassword";
import SingleResult from "./pages/admin/home/SingleResult";
import VerifyUser from "./pages/client/login/VerifyUser";
import CreateExam from "./pages/admin/home/CreateExam";
import DynamicExamMain from "./pages/client/exam/DynamicExamMain";
import GoogleLogin from "./pages/client/login/GoogleLogin";

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/google-login" element={<GoogleLogin />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset/:token" element={<ResetPassword />} />
          <Route path="/verify/:token" element={<VerifyUser />} />
          <Route
            path="client"
            element={<RequireAuth allowedRoles={["CLIENT"]} />}
          >
            <Route index element={<Home />} />
            <Route path="home" element={<Home />} />
            <Route path="topics" element={<TopicPage />} />
            <Route path="profile" element={<Profile />} />
            <Route path="Leaderboard" element={<LeaderBoard />} />
            <Route path="history" element={<History />} />
            <Route path="take-exam" element={<ExamMain />} />
            <Route path="result/:id" element={<HistoryViewPage />} />
            <Route path="dynamic-exam/:examId" element={<DynamicExamMain />} />
          </Route>
          <Route
            path="admin"
            element={<RequireAuth allowedRoles={["ADMIN"]} />}
          >
            <Route index element={<Users />} />
            <Route path="home" element={<Users />} />
            <Route path="question" element={<Question />} />
            <Route path="exam" element={<Exam />} />
            <Route path="create-exam" element={<CreateExam />} />
            <Route path="result" element={<Result />} />
            <Route path="/admin/result/:id" element={<SingleResult />} />
            <Route path="topics" element={<Topics />} />
            <Route path="profile" element={<AdminInfo />} />
            <Route path="add-question" element={<AddQuestion />} />
            <Route path="edit-question/:id" element={<EditQuestion />} />
            <Route path="edit-user/:id" element={<EditUser />} />
            <Route path="view-exam/:id" element={<ViewExam />} />
            <Route path="contactus" element={<ContactSubmitted />} />
          </Route>
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/*" element={<PageNotFound />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
